import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  TablePagination,
  Alert,
  CircularProgress,
  Tabs,
  Tab,
  Autocomplete,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  Inventory,
  Warning,
  CheckCircle,
  Cancel,
  GetApp,
  Refresh,
  Calculate,
  PriorityHigh
} from '@mui/icons-material';

const StokRaporlari = ({ path }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  
  // Genel Özet State
  const [genelOzet, setGenelOzet] = useState(null);
  
  // Detaylı Liste State
  const [stokListesi, setStokListesi] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 0, limit: 20 });
  const [filters, setFilters] = useState({
    search: '',
    stokDurumu: 'all',
    marka: '',
    renk: '',
    beden: '',
    sortBy: 'guncel_stok',
    sortOrder: 'DESC'
  });
  
  // Filtre Seçenekleri State
  const [filterOptions, setFilterOptions] = useState({
    markalar: [],
    renkler: [],
    bedenler: []
  });
  
  // Analiz State'leri
  const [bedenAnalizi, setBedenAnalizi] = useState([]);
  const [renkAnalizi, setRenkAnalizi] = useState([]);
  const [markaAnalizi, setMarkaAnalizi] = useState([]);
  const [kritikStok, setKritikStok] = useState([]);
  const [enCokSatan, setEnCokSatan] = useState([]);
  const [hesaplamaLoading, setHesaplamaLoading] = useState(false);

  // Genel özet verilerini çek
  const fetchGenelOzet = async () => {
    console.log('Genel özet verileri çekiliyor...', path);
    try {
      const response = await fetch(`${path}/rapor/genel-ozet`);
      console.log('Genel özet response:', response.status);
      const data = await response.json();
      console.log('Genel özet data:', data);
      if (data.success) {
        setGenelOzet(data.data);
      } else {
        console.error('Genel özet başarısız:', data.message);
      }
    } catch (error) {
      console.error('Genel özet hatası:', error);
    }
  };

  // Detaylı stok listesini çek
  const fetchStokListesi = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: pagination.page + 1,
        limit: pagination.limit,
        ...filters
      });
      
      console.log('Stok listesi parametreleri:', params.toString());
      const response = await fetch(`${path}/rapor/detayli-stok?${params}`);
      console.log('Stok listesi response:', response.status);
      const data = await response.json();
      console.log('Stok listesi data:', data);
      
      if (data.success) {
        setStokListesi(data.data);
        setPagination(prev => ({ ...prev, total: data.pagination.total }));
        console.log('Stok listesi güncellendi:', data.data.length, 'kayıt');
      } else {
        console.error('Stok listesi başarısız:', data.message);
      }
    } catch (error) {
      console.error('Stok listesi hatası:', error);
    }
    setLoading(false);
  };

  // Filtre seçeneklerini çek
  const fetchFilterOptions = async () => {
    try {
      const response = await fetch(`${path}/rapor/filtre-secenekleri`);
      const data = await response.json();
      if (data.success) {
        setFilterOptions(data.data);
      }
    } catch (error) {
      console.error('Filtre seçenekleri hatası:', error);
    }
  };

  // Stok hesaplama fonksiyonu
  const hesaplaStok = async () => {
    setHesaplamaLoading(true);
    try {
      console.log('Stok hesaplaması başlatılıyor...');
      const response = await fetch(`${path}/hesapla-stok`, {
        method: 'POST'
      });
      
      console.log('Stok hesaplama response:', response.status);
      const data = await response.json();
      console.log('Stok hesaplama sonucu:', data);
      
      if (data.success) {
        // Başarılı hesaplama sonrası verileri yenile
        await fetchGenelOzet();
        await fetchStokListesi();
        await fetchFilterOptions();
        
        const statsText = data.stats ? 
          `\nİşlenen: ${data.stats.processedProducts || 0}\nYeni: ${data.stats.insertedProducts || 0}\nGüncellenen: ${data.stats.updatedProducts || 0}` : 
          `\nİşlenen ürün sayısı: ${data.stats?.processedProducts || 'Bilinmiyor'}`;
          
        alert(`✅ Stok hesaplaması tamamlandı!${statsText}`);
      } else {
        alert(`❌ Stok hesaplaması başarısız!\n\n${data.message}`);
      }
    } catch (error) {
      console.error('Stok hesaplama hatası:', error);
      alert(`❌ Stok hesaplaması sırasında hata oluştu!\n\n${error.message}`);
    }
    setHesaplamaLoading(false);
  };

  // Excel export
  const handleExcelExport = async () => {
    try {
      const response = await fetch(`${path}/rapor/excel-export`);
      const data = await response.json();
      
      if (data.success) {
        // CSV formatında export
        const csvContent = [
          Object.keys(data.data[0]).join(','),
          ...data.data.map(row => Object.values(row).join(','))
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `stok-raporu-${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
      }
    } catch (error) {
      console.error('Excel export hatası:', error);
    }
  };

  // Stok durumu chip'i - FUNCTİON TANIMI BURAYA TAŞINDI
  const getStokDurumChip = (stok) => {
    if (stok < 0) return <Chip label="Eksik" color="error" size="small" />;
    if (stok === 0) return <Chip label="Tükendi" color="warning" size="small" />;
    if (stok > 0 && stok < 50) return <Chip label="Kritik" sx={{ backgroundColor: '#ff5722', color: 'white' }} size="small" />;
    if (stok <= 100) return <Chip label="Az" color="info" size="small" />;
    return <Chip label="Yeterli" color="success" size="small" />;
  };

  // Sayfa yüklendiğinde verileri çek
  useEffect(() => {
    const testConnection = async () => {
      try {
        console.log('API bağlantısı test ediliyor:', `${path}/rapor/genel-ozet`);
        const response = await fetch(`${path}/rapor/genel-ozet`);
        console.log('Test sonucu:', response.status, response.statusText);
        if (!response.ok) {
          console.error('API yanıt hatası:', await response.text());
        }
      } catch (error) {
        console.error('API bağlantı hatası:', error);
      }
    };
    
    testConnection();
    fetchGenelOzet();
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchStokListesi();
  }, [pagination.page, pagination.limit, filters]);

  // Genel Özet Kartları - Tıklanabilir butonlar (5 kart)
  const OzetKartlari = () => (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={2.4}>
        <Card 
          sx={{ 
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': { 
              transform: 'translateY(-4px)',
              boxShadow: 4,
              backgroundColor: '#f5f5f5'
            },
            border: filters.stokDurumu === 'all' ? '2px solid #2196f3' : '1px solid #e0e0e0'
          }}
          onClick={() => {
            setFilters({ ...filters, stokDurumu: 'all' });
            setPagination({ ...pagination, page: 0 });
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box display="flex" alignItems="center">
              <Inventory sx={{ fontSize: 32, color: '#2196f3', mr: 1.5 }} />
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Toplam Ürün
                </Typography>
                <Typography variant="h5">
                  {genelOzet?.toplam_urun_sayisi || 0}
                </Typography>
                <Typography variant="caption" color="primary" sx={{ fontWeight: 'bold' }}>
                  Tümünü Göster
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <Card 
          sx={{ 
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': { 
              transform: 'translateY(-4px)',
              boxShadow: 4,
              backgroundColor: '#f5f5f5'
            },
            border: filters.stokDurumu === 'pozitif' ? '2px solid #4caf50' : '1px solid #e0e0e0'
          }}
          onClick={() => {
            setFilters({ ...filters, stokDurumu: 'pozitif' });
            setPagination({ ...pagination, page: 0 });
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box display="flex" alignItems="center">
              <CheckCircle sx={{ fontSize: 32, color: '#4caf50', mr: 1.5 }} />
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Stokta Olan
                </Typography>
                <Typography variant="h5">
                  {genelOzet?.stokta_olan_urun || 0}
                </Typography>
                <Typography variant="caption" color="success.main" sx={{ fontWeight: 'bold' }}>
                  Filtrele
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <Card 
          sx={{ 
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': { 
              transform: 'translateY(-4px)',
              boxShadow: 4,
              backgroundColor: '#f5f5f5'
            },
            border: filters.stokDurumu === 'kritik' ? '2px solid #ff5722' : '1px solid #e0e0e0'
          }}
          onClick={() => {
            setFilters({ ...filters, stokDurumu: 'kritik' });
            setPagination({ ...pagination, page: 0 });
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box display="flex" alignItems="center">
              <PriorityHigh sx={{ fontSize: 32, color: '#ff5722', mr: 1.5 }} />
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Kritik Stok
                </Typography>
                <Typography variant="h5">
                  {genelOzet?.kritik_stoklu_urun || 0}
                </Typography>
                <Typography variant="caption" sx={{ color: '#ff5722', fontWeight: 'bold' }}>
                  &lt;50 Adet
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <Card 
          sx={{ 
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': { 
              transform: 'translateY(-4px)',
              boxShadow: 4,
              backgroundColor: '#f5f5f5'
            },
            border: filters.stokDurumu === 'sifir' ? '2px solid #ff9800' : '1px solid #e0e0e0'
          }}
          onClick={() => {
            setFilters({ ...filters, stokDurumu: 'sifir' });
            setPagination({ ...pagination, page: 0 });
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box display="flex" alignItems="center">
              <Warning sx={{ fontSize: 32, color: '#ff9800', mr: 1.5 }} />
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Stoku Biten
                </Typography>
                <Typography variant="h5">
                  {genelOzet?.stoku_biten_urun || 0}
                </Typography>
                <Typography variant="caption" color="warning.main" sx={{ fontWeight: 'bold' }}>
                  Filtrele
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <Card 
          sx={{ 
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': { 
              transform: 'translateY(-4px)',
              boxShadow: 4,
              backgroundColor: '#f5f5f5'
            },
            border: filters.stokDurumu === 'negatif' ? '2px solid #f44336' : '1px solid #e0e0e0'
          }}
          onClick={() => {
            setFilters({ ...filters, stokDurumu: 'negatif' });
            setPagination({ ...pagination, page: 0 });
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box display="flex" alignItems="center">
              <Cancel sx={{ fontSize: 32, color: '#f44336', mr: 1.5 }} />
              <Box>
                <Typography color="textSecondary" gutterBottom variant="body2">
                  Eksi Stoklu
                </Typography>
                <Typography variant="h5">
                  {genelOzet?.eksi_stoklu_urun || 0}
                </Typography>
                <Typography variant="caption" color="error.main" sx={{ fontWeight: 'bold' }}>
                  Filtrele
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  // Filtre Bölümü
  const FiltreBolumu = () => (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Filtreler
        </Typography>
        
        {/* Hızlı Filtre Butonları */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>Hızlı Filtreler:</Typography>
          <Grid container spacing={1}>
            <Grid item>
              <Button
                variant={filters.stokDurumu === 'all' ? 'contained' : 'outlined'}
                size="small"
                onClick={() => {
                  setFilters({ ...filters, stokDurumu: 'all' });
                  setPagination({ ...pagination, page: 0 });
                }}
                startIcon={<Inventory />}
              >
                Tümü ({genelOzet?.toplam_urun_sayisi || 0})
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant={filters.stokDurumu === 'pozitif' ? 'contained' : 'outlined'}
                size="small"
                color="success"
                onClick={() => {
                  setFilters({ ...filters, stokDurumu: 'pozitif' });
                  setPagination({ ...pagination, page: 0 });
                }}
                startIcon={<CheckCircle />}
              >
                Stokta ({genelOzet?.stokta_olan_urun || 0})
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant={filters.stokDurumu === 'kritik' ? 'contained' : 'outlined'}
                size="small"
                sx={{ 
                  color: filters.stokDurumu === 'kritik' ? 'white' : '#ff5722',
                  backgroundColor: filters.stokDurumu === 'kritik' ? '#ff5722' : 'transparent',
                  borderColor: '#ff5722',
                  '&:hover': { 
                    backgroundColor: '#ff5722', 
                    color: 'white' 
                  }
                }}
                onClick={() => {
                  setFilters({ ...filters, stokDurumu: 'kritik' });
                  setPagination({ ...pagination, page: 0 });
                }}
                startIcon={<PriorityHigh />}
              >
                Kritik ({genelOzet?.kritik_stoklu_urun || 0})
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant={filters.stokDurumu === 'sifir' ? 'contained' : 'outlined'}
                size="small"
                color="warning"
                onClick={() => {
                  setFilters({ ...filters, stokDurumu: 'sifir' });
                  setPagination({ ...pagination, page: 0 });
                }}
                startIcon={<Warning />}
              >
                Tükenen ({genelOzet?.stoku_biten_urun || 0})
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant={filters.stokDurumu === 'negatif' ? 'contained' : 'outlined'}
                size="small"
                color="error"
                onClick={() => {
                  setFilters({ ...filters, stokDurumu: 'negatif' });
                  setPagination({ ...pagination, page: 0 });
                }}
                startIcon={<Cancel />}
              >
                Eksik ({genelOzet?.eksi_stoklu_urun || 0})
              </Button>
            </Grid>
          </Grid>
        </Box>
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={2}>
            <TextField
              fullWidth
              label="Ürün Kodu Ara"
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              size="small"
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Stok Durumu</InputLabel>
              <Select
                value={filters.stokDurumu}
                label="Stok Durumu"
                onChange={(e) => {
                  setFilters({ ...filters, stokDurumu: e.target.value });
                  setPagination({ ...pagination, page: 0 });
                }}
                sx={{
                  backgroundColor: filters.stokDurumu !== 'all' ? 
                    (filters.stokDurumu === 'pozitif' ? '#e8f5e8' :
                     filters.stokDurumu === 'kritik' ? '#ffebee' :
                     filters.stokDurumu === 'sifir' ? '#fff3e0' :
                     filters.stokDurumu === 'negatif' ? '#ffebee' : 'white') : 'white'
                }}
              >
                <MenuItem value="all">🔍 Tümü</MenuItem>
                <MenuItem value="pozitif">🟢 Stokta Olan</MenuItem>
                <MenuItem value="kritik">🟠 Kritik Stok (&lt;50)</MenuItem>
                <MenuItem value="sifir">🟡 Stoku Biten</MenuItem>
                <MenuItem value="negatif">🔴 Eksi Stoklu</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Autocomplete
              options={filterOptions.markalar || []}
              value={filters.marka || null}
              onChange={(e, newValue) => setFilters({ ...filters, marka: newValue || '' })}
              isOptionEqualToValue={(option, value) => option === value}
              renderInput={(params) => <TextField {...params} label="Marka" size="small" />}
              freeSolo
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Autocomplete
              options={filterOptions.renkler || []}
              value={filters.renk || null}
              onChange={(e, newValue) => setFilters({ ...filters, renk: newValue || '' })}
              isOptionEqualToValue={(option, value) => option === value}
              renderInput={(params) => <TextField {...params} label="Renk" size="small" />}
              freeSolo
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Autocomplete
              options={filterOptions.bedenler || []}
              value={filters.beden || null}
              onChange={(e, newValue) => setFilters({ ...filters, beden: newValue || '' })}
              isOptionEqualToValue={(option, value) => option === value}
              renderInput={(params) => <TextField {...params} label="Beden" size="small" />}
              freeSolo
            />
          </Grid>
          
          <Grid item xs={12} md={1}>
            <Tooltip title="Verileri Yenile">
              <IconButton 
                onClick={() => {
                  fetchStokListesi();
                  fetchGenelOzet();
                }} 
                color="primary"
                disabled={loading}
              >
                <Refresh />
              </IconButton>
            </Tooltip>
          </Grid>
          
          <Grid item xs={12} md={1}>
            <Tooltip title="Stok Hesapla">
              <IconButton 
                onClick={hesaplaStok}
                color="secondary"
                disabled={hesaplamaLoading}
                sx={{ 
                  backgroundColor: hesaplamaLoading ? 'grey.300' : 'secondary.light',
                  '&:hover': { backgroundColor: 'secondary.main' }
                }}
              >
                <Calculate />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Detaylı Stok Tablosu
  const DetayliStokTablosu = () => (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">
            Detaylı Stok Listesi
          </Typography>
          <Button
            startIcon={<GetApp />}
            onClick={handleExcelExport}
            variant="outlined"
            size="small"
          >
            Excel İndir
          </Button>
        </Box>
        
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Ürün Kodu</strong></TableCell>
                    <TableCell><strong>Marka</strong></TableCell>
                    <TableCell><strong>Renk</strong></TableCell>
                    <TableCell><strong>Beden</strong></TableCell>
                    <TableCell align="right"><strong>Alış</strong></TableCell>
                    <TableCell align="right"><strong>Satış</strong></TableCell>
                    <TableCell align="right"><strong>Stok</strong></TableCell>
                    <TableCell><strong>Durum</strong></TableCell>
                    <TableCell align="right"><strong>Birim Fiyat</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stokListesi.map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                          {item.urun_kodu}
                        </Typography>
                      </TableCell>
                      <TableCell>{item.marka || '-'}</TableCell>
                      <TableCell>{item.renk || '-'}</TableCell>
                      <TableCell>
                        <Chip label={item.beden || '-'} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell align="right">
                        <Typography color="primary">{item.toplam_alis}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography color="secondary">{item.toplam_satis}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography 
                          sx={{ 
                            fontWeight: 'bold',
                            color: item.guncel_stok < 0 ? 'error.main' : 
                                   item.guncel_stok === 0 ? 'warning.main' : 'success.main'
                          }}
                        >
                          {item.guncel_stok}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {getStokDurumChip(item.guncel_stok)}
                      </TableCell>
                      <TableCell align="right">
                        {item.son_alis_fiyati ? `$${item.son_alis_fiyati}` : '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            <TablePagination
              component="div"
              count={pagination.total}
              page={pagination.page}
              onPageChange={(e, newPage) => setPagination({ ...pagination, page: newPage })}
              rowsPerPage={pagination.limit}
              onRowsPerPageChange={(e) => setPagination({ ...pagination, limit: parseInt(e.target.value), page: 0 })}
              rowsPerPageOptions={[10, 20, 50, 100]}
              labelRowsPerPage="Sayfa başına"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
            />
          </>
        )}
      </CardContent>
    </Card>
  );

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1">
          📊 Stok Raporları ve Analizi
        </Typography>
        
        {/* Stok Hesaplama Butonu */}
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Calculate />}
          onClick={hesaplaStok}
          disabled={hesaplamaLoading}
          size="large"
          sx={{
            backgroundColor: '#9c27b0',
            '&:hover': { backgroundColor: '#7b1fa2' },
            boxShadow: 3
          }}
        >
          {hesaplamaLoading ? 'Hesaplanıyor...' : 'Stok Hesapla'}
        </Button>
      </Box>
      
      {/* Loading indicator for calculation */}
      {hesaplamaLoading && (
        <Box sx={{ mb: 3 }}>
          <Alert severity="info" sx={{ display: 'flex', alignItems: 'center' }}>
            <CircularProgress size={20} sx={{ mr: 2 }} />
            Stok hesaplaması devam ediyor... Alış ve satış verileri karşılaştırılıyor.
          </Alert>
        </Box>
      )}
      
      {/* Genel Özet Kartları */}
      <OzetKartlari />
      
      {/* Aktif Filtre Bilgisi */}
      {filters.stokDurumu !== 'all' && (
        <Alert 
          severity="info" 
          sx={{ mb: 3 }}
          action={
            <Button 
              color="inherit" 
              size="small" 
              onClick={() => {
                setFilters({ ...filters, stokDurumu: 'all' });
                setPagination({ ...pagination, page: 0 });
              }}
            >
              Temizle
            </Button>
          }
        >
          <Typography variant="body2">
            <strong>Aktif Filtre:</strong> {
              filters.stokDurumu === 'pozitif' ? '🟢 Stokta Olan Ürünler' :
              filters.stokDurumu === 'kritik' ? '🟠 Kritik Stoklu Ürünler (50 altı)' :
              filters.stokDurumu === 'sifir' ? '🟡 Stoku Biten Ürünler' :
              filters.stokDurumu === 'negatif' ? '🔴 Eksi Stoklu Ürünler' : ''
            } gösteriliyor.
          </Typography>
        </Alert>
      )}
      
      {/* Eğer stok verisi yoksa uyarı göster */}
      {genelOzet && genelOzet.toplam_urun_sayisi === 0 && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            ⚠️ Stok Verisi Bulunamadı
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Henüz stok hesaplaması yapılmamış görünüyor. Lütfen önce aşağıdaki adımları tamamlayın:
          </Typography>
          <Box component="ol" sx={{ ml: 2 }}>
            <li>Alış Excel dosyanızı yükleyin</li>
            <li>Satış Excel dosyanızı yükleyin</li>
            <li><strong>"Stok Hesapla"</strong> butonuna tıklayın</li>
          </Box>
        </Alert>
      )}
      
      {/* Tab Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
          <Tab label="Detaylı Liste" />
          <Tab label="Basit Görünüm" />
        </Tabs>
      </Box>
      
      {/* Tab Content */}
      <TabPanel value={activeTab} index={0}>
        <Box>
          <FiltreBolumu />
          <DetayliStokTablosu />
        </Box>
      </TabPanel>
      
      <TabPanel value={activeTab} index={1}>
        <Alert severity="info">
          Diğer analizler yakında eklenecek...
        </Alert>
      </TabPanel>
    </Box>
  );
};

export default StokRaporlari;